import { getConciliationAmountLimit } from '../../../../../../utils/conciliationAmountLimit'
import { Box, Dialog, DialogActions, DialogContent, IconButton } from '@mui/material'
import Slider from '@mui/material/Slider'
import CustomButton from '../../../../../ui/CustomButton'
import { Title } from '../../../../../ui'
import ArrowIcon from '@mui/icons-material/KeyboardArrowUpOutlined'
import DownIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { useContext, useEffect, useState } from 'react'
import TableMovVincular from './TableMovVincular'
//import {currentMonth,currentYear} from '../../../../../../utils/constant'
import { BusinessAPI } from '../../../../../../../api/business.api'
import GlobalContext from '../../../../../../../context/global-context'
import dayjs from 'dayjs'
import FilterDateControl from '../../../../../table/FilterDateControl'

const InputField = ({ label, placeholder, type }) => (
    <div>
      <label className='block text-sm font-medium text-gray-700'>{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        className='mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
      />
    </div>
)
  
const ModalMovimientosPorVincular = ({open, setOpen, onSelectMovimiento, type}) => {
    const [value, setValue] = useState([1, getConciliationAmountLimit(0)])
    const [showFilters, setShowFilters] = useState(true)
    const [isAnyCheckboxSelected, setIsAnyCheckboxSelected] = useState(false)
    const businessAPI = new BusinessAPI()
    const [, setMonthFilter] = useState(dayjs().format('MM'))
    const [, setYearFilter] = useState(dayjs().format('YYYY'))
    const [filters] = useState({
      fechaInicio: dayjs().startOf('year').format('YYYY-MM-DD'),
      fechaFin: dayjs().format('YYYY-MM-DD'),
    })
    const [tempFilters, setTempFilters] = useState({ ...filters })
    const { ui, currentBusiness } = useContext(GlobalContext)
    const [data, setData] = useState([])
    const [selectedId, setSelectedId] = useState(null)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [selectedBank, setSelectedBank] = useState('')
    const [bancosUnicos, setBancosUnicos] = useState([])
  
    // This picker has no source document; derive its range from the available movements.
    const amountLimit = getConciliationAmountLimit(data.reduce((max, item) =>
      Math.max(max, Math.abs(Number(item.montoTotal ?? item.montoCargo ?? item.montoAbono) || 0)), 0))
    useEffect(() => {
      setValue([1, amountLimit])
    }, [amountLimit, open])

    const handleClose = () => setOpen(false)
  
    const handleChange = (event, newValue) => {
      setValue(newValue)
    }

    /*const handleCheckboxChange = (isSelected) => {
      setIsAnyCheckboxSelected(isSelected)
    }*/

    const handleCheckboxChange = (selectedRow) => {
      setSelectedId(selectedRow.id)
      setIsAnyCheckboxSelected(!!selectedRow)
    }
    
    const handleConciliar = () => {
      if (selectedId) {
        const selectedRowData = data.find((item) => item.id === selectedId)
        setOpen(false)
        onSelectMovimiento(selectedRowData)
      }
    }

    //egreso son
    const getData = async () => {
      //const monthFormatter = monthFilter.toString().length === 1 ? `0${monthFilter}` : monthFilter
      
      try {
        ui.setLoader({ visible: true})
        const response = await businessAPI.getTransacciones({
          businessId: currentBusiness.id,
          type: type,
        })
        setData(response.data)
        const bancos = Array.from(
          new Set(
            (response.data || [])
              .map((item) => item.nombreCuentaBanco?.trim())
              .filter((nombre) => nombre && nombre.toLowerCase() !== 'caja principal')
          )
        )
        setBancosUnicos(['Caja Principal', ...bancos])
      } catch (error) {
        console.error(error)
      } finally {
        ui.setLoader({visible: false})
      }
    }
    useEffect(() => {
        getData()
      }, [currentBusiness])

    const handleDateChange = (key, newValue) => {
      const newDate = dayjs(newValue)
      setTempFilters((prev) => ({
      ...prev,
      [key]: newDate.format('YYYY-MM-DD'),
      }))
      
      // Solo actualizar month y year cuando cambia la fecha de inicio
      if (key === 'fechaInicio') {
      setMonthFilter(newDate.format('MM'))
      setYearFilter(newDate.format('YYYY'))
      }
    }

    const filteredRows = (data || []).filter((item) => {
      const matchesKeyword = item.descripcion?.toLowerCase().includes(searchKeyword.toLowerCase())
      const matchesBank = selectedBank 
      ? item.nombreCuentaBanco?.trim().toLowerCase() === selectedBank.toLowerCase()
      : true
      return matchesKeyword && matchesBank
      })

    return (
      <>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        maxWidth='lg'
        scroll='body'
        PaperProps={{
          sx: {
            backgroundColor: '#f2f2f2',
            borderRadius: '8px',
            padding: '16px',
          },
        }}
      >
        <DialogContent>
        <div className='relative w-full flex justify-end'>
          <IconButton
            onClick={() => setShowFilters(!showFilters)}
          >
            {showFilters ? <ArrowIcon /> : <DownIcon />}
          </IconButton>
        </div>
        <Title className='text-3xl mb-4'>Movimientos por vincular</Title>
          {showFilters && (
            <div className='p-4 bg-white rounded-3xl shadow-md mb-10'>
            <div className='grid grid-cols-3 gap-4'>
                <div>
                    <InputField label='Palabra Clave' type='text' value={searchKeyword} onChange={(e) => setSearchKeyword(e.target.value)}/>
                </div>
                <div className='pt-8'>
                    <FilterDateControl
                        label="Fecha Desde"
                        value={tempFilters.fechaInicio}
                        onChange={(newValue) => handleDateChange("fechaInicio", newValue)}
                    />
                </div>
                <div className='pt-8'>
                    <FilterDateControl
                        label="Fecha Hasta"
                        value={tempFilters.fechaFin}
                        onChange={(newValue) => handleDateChange("fechaFin", newValue)}
                    />
                </div>
                <div>
                    <label className='block text-sm font-medium text-gray-700'>Monto</label>
                    <Box sx={{ width: '100%' }}>
                    <div className='flex justify-between text-sm text-gray-500 mb-1'>
                        <span>${value[0].toLocaleString()}</span>
                        <span>${value[1].toLocaleString()}</span>
                    </div>
                    <Slider
                        getAriaLabel={() => 'Monto range'}
                        value={value}
                        onChange={handleChange}
                        valueLabelDisplay='off'
                        min={1}
                        max={amountLimit}
                    />
                    </Box>
                </div>
                <div>
                    <label className='block text-sm font-medium text-gray-700'>Banco</label>
                    <select
                    className='mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                    value={selectedBank}
                    onChange={(e) => setSelectedBank(e.target.value.trim())}
                    >
                    <option value=''>Todos los bancos</option>
                    {bancosUnicos.map((bank, i) => (
                        <option key={i} value={bank}>{bank}</option>
                    ))}
                    </select>
                </div>
            </div>
        </div>
          )}
          <Title className='text-2xl mb-4'>Sugerencias</Title>
          <div className='p-4 rounded-lg shadow-md bg-white'>
            <div className='overflow-x-auto'>
              <TableMovVincular onCheckboxChange={handleCheckboxChange} rows={filteredRows}/>
            </div>
          </div>
        </DialogContent>
  
        <DialogActions>
          <CustomButton color='accent2' className='rounded-full' title='CONCILIAR MOVIMIENTOS' disabled={!isAnyCheckboxSelected} onClick={handleConciliar}/>
          <CustomButton color='primary' onClick={handleClose} className='rounded-full' title='CANCELAR' />
        </DialogActions>
      </Dialog>
      </>
    )
}

export default ModalMovimientosPorVincular
